import selectedTradesSlice from './selectedTradesSlice';

export const {
  updateSelectedTrade,
  updateSelectedTradeUpcomingProxy,
  updateSelectedTradeAuctionSummary,
  updateSelectedTradeIsWatchlisted,
  updateSelectedTradeIsAuctionEnded
} = selectedTradesSlice.actions;

export const { reducer } = selectedTradesSlice;
